import { createAsyncThunk } from "@reduxjs/toolkit";
import { logWebVisit } from "./webVisit.service";
import { WebVisitPayload, WebVisitResponse } from "./webVisit.types";
import { RejectValueType } from "../redux/redux.types";
import { RootState } from "../../store";
import { handleApiError } from "@/app/utils/handleApiError";

export const postWebVisit = createAsyncThunk<
  WebVisitResponse,
  WebVisitPayload,
  RejectValueType & { state: RootState }
>(
  "webVisit/postWebVisit",
  async (data, { rejectWithValue }) => {
    try {
      const response = await logWebVisit(data);
      return response;
    } catch (error) {
      return rejectWithValue(handleApiError(error));
    }
  },
  {
    condition: (_, { getState }) => {
      const { webVisit } = getState();
      if (webVisit.logged) return false;
      if (webVisit.status === "loading") return false;
      return true;
    },
  },
);
